import { createBrowserHistory } from 'history';

// Make singleton history object to allow util code to do redirects...
// https://stackoverflow.com/questions/44153517/how-to-access-history-object-outside-of-a-react-component
// https://github.com/ReactTraining/react-router/issues/5237#issuecomment-376685224

// motivated by need to have Auth.refreshToken() be able to redirect to /login once the 
// refresh token expires

export const history = createBrowserHistory();
